import { Box, Divider, Stack, styled, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CustomSearchInput from "@/components/custom/custom-search-input";
import { CustomButton } from "@/components/custom/custom-button";
import { DataTable } from "@/components/custom/data-table";
import CustomPagination from "@/components/custom/custom-pagination";
import { useActivityLogs } from "@/hooks/use-activity-logs";
import { ActivityColumns } from "./_components/activity-column";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export default function ActivityLog() {
  const [searchParams] = useSearchParams();

  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const { data, isLoading, isError } = useActivityLogs({
    page: currentPage,
    size: pageSize,
    search: searchValue,
  });

  return (
    <Box sx={{ m: 2 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" fontWeight={600}>
          Activity Logs
        </Typography>
        <Typography variant="body2" color="text.secondary">
          View and manage activity logs across services
        </Typography>
      </Box>

      <RootWrapper>
        <Card>
          <Stack
            direction={"row"}
            spacing={3}
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction={"row"} spacing={3}>
              <CustomSearchInput
                paramKey="search"
                placeholder="Search activities..."
              />
            </Stack>

            <CustomButton
              variantType="outline"
              endIcon={<FileDownloadOutlinedIcon fontSize="small" />}
              onClick={() => {}}
              isLoading={false}
              sx={{ height: 35 }}
            >
              Export
            </CustomButton>
          </Stack>

          <Divider />

          <DataTable
            data={data?.data ?? []}
            columns={ActivityColumns}
            isLoading={isLoading}
            isError={isError}
          />
          <CustomPagination
            total={data?.totalCount ?? 0}
            perPageOptions={[5, 10, 20, 50, 100]}
          />
        </Card>
      </RootWrapper>
    </Box>
  );
}
